// Estados de una solicitud para los filtros de RequestList y StoreroomRequestList (tabla y panel
// móvil). La clave 'undefined' (string) es "sin filtro": así la espera el backend.
export const ESTADOS = {
  undefined: 'Todos',
  'Recibida': 'Recibida',
  'En proceso': 'En proceso',
  'Entregado': 'Entregado',
  'Finalizado': 'Finalizado',
  'Listo para retiro': 'Listo para retiro',
  'Rechazado': 'Rechazado',
};
